//====================================================
//  Function: Remove 
//====================================================
function fn_parts_remove(){
	if ($( '.js-remove-trigger' ).length){
		$( document ).on( 'click', '.js-remove-trigger' , function(e) {
			e.preventDefault();
			$(this).closest( '.js-remove-block' ).removeClass( class_active );
		});
	}
}
